import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './contratoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

import { setModoTela, initForm, salvar, excluir, getLista } from './contratoActions';
import { getLista as getListaGrupoFaturamento } from '../grupoFaturamento/grupoFaturamentoActions';
import { getLista as getListaHospital } from '../hospital/hospitalActions';

class Contrato extends Component {

	state = {
		linhaSelecionada: null
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaGrupoFaturamento();
		this.props.getListaHospital();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'convenio' ? (
						<Form convenio />
					) : null}
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		let lista = (this.props.lista).filter(item => {
			if (this.state.pesquisar
				&& !(`${item.nome} ${item.nome_grupo_faturamento} ${item.nome_fantasia_hospital}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		});

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>

					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value, paginacaoIndice: 0 });
						}} />

					<Table responsive>
						<THead>
							<Tr>
								<Th>Grupo de Faturamento</Th>
								<Th alignCenter>Hospital</Th>
								<Th alignCenter>Início</Th>
								<Th alignCenter>Fim</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.nome_grupo_faturamento}</Td>
									<Td alignCenter>{item.nome_fantasia_hospital}</Td>
									<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_inicio)}</Td>
									<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.data_fim)}</Td>
									<Td alignRight minWidth={10}>																			
										<ButtonTable
											title='Exames'
											type={'primary'}
											icon={'fas fa-list'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('convenio', {
													...item,
													percentual_reajuste: FormatUtils.formatarValorTela(item.percentual_reajuste, 2),
													percentual_imposto_escritorio: FormatUtils.formatarValorTela(item.percentual_imposto_escritorio, 2)
												});
												this.props.initForm({
													...item,
													percentual_reajuste: FormatUtils.formatarValorTela(item.percentual_reajuste, 2),
													percentual_imposto_escritorio: FormatUtils.formatarValorTela(item.percentual_imposto_escritorio, 2)
												});
											}} />

										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													percentual_reajuste: FormatUtils.formatarValorTela(item.percentual_reajuste, 2),
													percentual_imposto_escritorio: FormatUtils.formatarValorTela(item.percentual_imposto_escritorio, 2)
												});
												this.props.initForm({
													...item,
													percentual_reajuste: FormatUtils.formatarValorTela(item.percentual_reajuste, 2),
													percentual_imposto_escritorio: FormatUtils.formatarValorTela(item.percentual_imposto_escritorio, 2)
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													percentual_reajuste: FormatUtils.formatarValorTela(item.percentual_reajuste, 2),
													percentual_imposto_escritorio: FormatUtils.formatarValorTela(item.percentual_imposto_escritorio, 2)
												});
												this.props.initForm({
													...item,
													percentual_reajuste: FormatUtils.formatarValorTela(item.percentual_reajuste, 2),
													percentual_imposto_escritorio: FormatUtils.formatarValorTela(item.percentual_imposto_escritorio, 2)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.contrato.modoTela,
	aguardando: state.contrato.aguardando,
	lista: state.contrato.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, getListaGrupoFaturamento, getListaHospital
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Contrato);